import validateRegex from "./regex"

export default function validateLettersAndNumbers(value) {
  return validateRegex(value, /^[0-9a-ząćęłńóśźżA-ZĄĆĘŁÓŃŚŹŻ-]+$/)
}